import axios from "axios";

export const base_url = "https://dev-api.grandrf.com/";

export const api_call = axios.create({
  baseURL: base_url,
  timeout: 300000,
  headers: { "Content-Type": "application/json" },
  validateStatus: function (status) {
    return status < 500;
  },
  transformRequest: [
    function (data, headers) {
      return JSON.stringify(data);
    },
  ],
});

const fetchClient = () => {
  let instance = axios.create({
    baseURL: base_url,
    timeout: 300000,
    headers: { "Content-Type": "application/json" },
    validateStatus: function (status) {
      return status < 500;
    },
    transformRequest: [
      function (data, headers) {
        return JSON.stringify(data);
      },
    ],
  });
  instance.interceptors.request.use(function (config) {
    const token = JSON.parse(localStorage.getItem("accessToken"));
    config.headers.Authorization = token ? `Bearer ${token}` : "";
    return config;
  });
  instance.interceptors.response.use((res) => {
    if (res.status === 401) {
      localStorage.removeItem("userData");
      localStorage.removeItem("cartData");
      localStorage.removeItem("accessToken");
      localStorage.removeItem("adddressName");
      window.location.reload();
    }
    return res;
  });
  return instance;
};

export const api_call_token = fetchClient();

export async function formDataApi(formData) {
  let user = {};
  const token = JSON.parse(localStorage.getItem("accessToken"));
  await axios
    .post(base_url + "auth/user/update_profile/", formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "content-type": "multipart/form-data",
      },
    })
    .then((response) => {
      if (response.status === 200) user = response.data?.data?.user;
    })
    .catch((e) => console.log(e));
  return user;
}
